import React from "react";
import "./Spinner.css"; // Create CSS for the spinner

const Spinner = () => {
    console.log("Spinner is rendering...");
  return (
    <div className="spinner-overlay">
      <div className="spinner"></div>
    </div>
  );
};

export default Spinner;
